export default __webpack_public_path__ + "static/media/como-cadastrar-moca3.5df1dac2.svg";